"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
exports.StyledInput = styled_1.default.input `
	width: 100%;
	max-width: 460px;
	border: 1px solid ${theme_1.default.colours.delimiter.default};
	border-radius: 0;
	height: 2.8125rem;
	line-height: ${theme_1.default.typography.styles.c1.height};
	font-size: ${theme_1.default.typography.styles.c1.size};
	font-family: ${theme_1.default.typography.fonts.base};
	font-weight: normal;
	color: ${theme_1.default.colours.text.dark};
	background: #fff;
	padding: 0 ${theme_1.default.spacing.default};
	transition: border ${theme_1.default.motion.transition.default};

	:active,
	:focus {
		border-color: ${theme_1.default.colours.primary.default};
		outline: none;
	}

${(props) => {
    return !props.invalid ? '' : `
	border-color: ${theme_1.default.colours.error.default};
	outline: 1px solid ${theme_1.default.colours.error.default};
	color: ${theme_1.default.colours.error.default};
	background: ${theme_1.default.colours.error.light};

	:active,
	:focus {
		border-color: ${theme_1.default.colours.error.default};
		outline: 1px solid ${theme_1.default.colours.error.default};
	}
	`;
}}
`;
//# sourceMappingURL=input.styled.js.map